import { apiSlice } from '../../../store/api/apiSlice';

export interface MemberOnboardingFlagState {
  key: string;
  enabled: boolean;
  globally_enabled: boolean;
  assigned: boolean;
}

export interface MemberOnboardingSessionFirstState {
  coach_id?: string;
  active_coach_count: number;
  enabled: boolean;
}

export interface MemberOnboardingReviewEntry {
  line: number;
  input: string;
  email?: string;
  status: string;
  reason?: string;
  duplicate_of_line?: number;
  person_id?: string;
  name?: string;
  flags?: Record<string, MemberOnboardingFlagState>;
  session_first?: MemberOnboardingSessionFirstState;
}

export interface MemberOnboardingReview {
  review_fingerprint: string;
  can_apply: boolean;
  entries: MemberOnboardingReviewEntry[];
  summary: {
    ready: number;
    blocking: number;
    duplicates: number;
    /** Historical rollout summary; current reviews do not emit it. */
    already_enabled?: number;
  };
}

export interface MemberOnboardingRun {
  id: string;
  status: string;
  input_count: number;
  resolved_member_count: number;
  created_at: string;
  started_at?: string;
  completed_at?: string;
  error_message?: string;
  summary?: Record<string, number>;
  backfill_status?: string;
}

export interface MemberOnboardingRunMember {
  run_id: string;
  member_person_id: string;
  email: string;
  status: string;
  members_only_result: string;
  session_assets_result: string;
  eligible_transcript_count: number;
  reused_reflection_count: number;
  enqueued_job_count: number;
  generated_reflection_count: number;
  suppressed_notification_count: number;
  error_message?: string;
}

export interface MemberOnboardingRunDetails {
  run: MemberOnboardingRun;
  aggregate: Record<string, number>;
  members: MemberOnboardingRunMember[];
}

export const memberOnboardingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    reviewMemberOnboarding: builder.mutation<MemberOnboardingReview, { emails: string }>({
      query: (body) => ({
        url: '/admin/member-onboarding/review',
        method: 'POST',
        body,
      }),
    }),
    applyMemberOnboarding: builder.mutation<
      {
        run: MemberOnboardingRun;
        publication_pending?: boolean;
        review_entry_counts?: Record<string, number>;
      },
      { emails: string; review_fingerprint: string }
    >({
      query: (body) => ({
        url: '/admin/member-onboarding/apply',
        method: 'POST',
        body,
      }),
    }),
    getMemberOnboardingRun: builder.query<MemberOnboardingRunDetails, string>({
      query: (runId) => `/admin/member-onboarding/runs/${runId}`,
    }),
  }),
});

export const {
  useReviewMemberOnboardingMutation,
  useApplyMemberOnboardingMutation,
  useGetMemberOnboardingRunQuery,
} = memberOnboardingApi;
